module.exports = __webpack_public_path__ + "img/new-edit-icon.6ce10e79.svg";